import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { element } from 'protractor';
import { environment } from 'src/environments/environment';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-college-mapping',
  templateUrl: './college-mapping.component.html',
  styleUrls: ['./college-mapping.component.scss'],
})
export class CollegeMappingComponent implements OnInit {
  courseForm: FormGroup;
  CourseSearchForm: FormGroup;
  courseList: any[];
  filteredCourseList: any;
  collegeList: [];
  clgcourseData: any[] = [];
  filteredclg: any[] = [];
  filteredCollegeList: any;
  courseData = [];
  isShown = false;
  collegeOneList: any;
  courseOneList: any;
  isShownCourseList = false;
  isShownCollegeList = false;
  isShownCourseDiv = false;
  isShownCollegeDiv = false;
  isCollegeRadioBtn = false;
  isCourseRadioBtn = false;
  isShownBranchDiv =false
  submitcourse = false;
  reset = false;
  submitcollege = false;
  // clgArr:any[];
  // courseArr:any[];
  map = new Map<String, String>();
  collegecourseList: any;
  checked: boolean;
  dialogRef: MatDialogRef<any>;
  uncheckedcourseList = [];
  checkedcourseList = [];
  uncheckedCollageList = [];
  checkedCollageList = [];
  coursesearchList: any;
  selectCourse: any;
  selectCollege: any;
  collegecourseList2: any;
  SessionNo: any;
  setIntervalSearch: any;  
  BranchList: any;
  filteredListBranch: any;
  constructor(
    public umsService: UmsService,
    private fb: FormBuilder,
    private httpClient: HttpClient,
    public router: Router,
    private spinner: NgxSpinnerService,
    private modalPopupService: ModalpopService
  ) { }
  collegeId;
  courseId;
  CollegeArr: FormArray;
  CourseArr: FormArray;
  userPermission: any;
  utp: string;
  searchTerm: string = '';
  ColgMapCreate = true;
  ColgMapUpdate = true;
  pageSize = 10;
  searchText
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  email="";
  searchtext : string;
  // ... Other code
  courses: any[] = [];
  UserCollege
  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin') {
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
        if (element.PageName == 'College-Mapping' && element.PCreate == false) {
          this.ColgMapCreate = false;
        }
      });
    }
    window.scroll(0, 0);
    this.isCollegeRadioBtn = true;
    this.isCourseRadioBtn = true;
    this.isShownCourseList = false;
    this.isShownCollegeList = false;
    this.reset = false;
    this.submitcollege = false;
    this.submitcourse = false;
    this.isShownCourseDiv = false;
    this.isShownCollegeDiv = false;
    this.isShownBranchDiv = false;
    this.courseForm = this.fb.group({
      course: new FormControl(''),
      college: new FormControl(''),
      CoStr: new FormControl(''),
      CollegeArr: this.fb.array([]),
      CourseArr: this.fb.array([]),
      radio: new FormControl(),
    });
    this.CourseSearchForm = this.fb.group({
      SearchString: new FormControl('')
    })
    let id = {};
    // this.fetchSelectedCourseCollege(id);
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      }
    );
  }

  // getControls() {
  //   return (this.courseForm.get('CollegeArr') as FormArray).controls;
  // }
  // getControls1() {
    
  //   return (this.courseForm.get('CourseArr') as FormArray).controls;
   
    
  // }

  getControls() {
 
    if (this.searchTerm === '') {
      return (this.courseForm.get('CollegeArr') as FormArray).controls;
    } else {
      return (this.courseForm.get('CollegeArr') as FormArray).controls.filter(control =>  control.value.CoCgCgCode.toLowerCase().includes(this.searchTerm) )
    }
  }
  getControls1() {
    if (this.searchTerm === '') {
      return (this.courseForm.get('CourseArr') as FormArray).controls;
    } else {
      return (this.courseForm.get('CourseArr') as FormArray).controls.filter(control =>  control.value.CoCgCoCode.toLowerCase().includes(this.searchTerm) )
    }
  }
  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    // const newPageIndex = Math.floor(event.pageSize * event.pageIndex / this.pageSize);
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    // this.getCollegeData();
  }
  keypress() {
    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      this.courseList = [];
    const payload = {};
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    payload['SearchString'] = this.CourseSearchForm.value;
    this.umsService.getCourse(this.CourseSearchForm.value).subscribe(res => {
      this.coursesearchList = res.data;
      this.totalItems = res.data[0].TotalRecords;
    }, (ERROR: HttpErrorResponse) => {
      this.courseList = [];
    });
    },1000)
   

  }

  clgClick() {
    this.spinner.show();
    let payload = this.courseForm.value;
    if(this.userPermission[0].CgUi == 'C'){
      this.UserCollege= this.userPermission[0].CgId;
    }
    else{
      this.UserCollege = ''
    }
    payload['CgCode'] = this.UserCollege;
    this.courseForm.controls["college"].setValue('');
    let bar = new Promise<void>((resolve, reject) => {
      this.umsService.getCollege(payload).subscribe((res) => {
        this.spinner.hide();
        if (res.status) {
          this.collegeList = res.data;
          this.filteredCollegeList = this.collegeList.slice();
        }
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Alert';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      });
      this.isCollegeRadioBtn = true;
      this.isCourseRadioBtn = false;
      this.isShownCollegeDiv = true;
      this.isShownCourseDiv = false;
      this.isShownBranchDiv =false
      this.isShownCourseList = false;
      this.isShownCollegeList = false;
      resolve();
    });
    // bar.then(() => {
    //   this.addclgcourse();
    // });
  }

  fetchBranch(id) {
    console.log(id);
    const payload = {};
    payload['CoCode'] = id;
    payload['EmId'] = 0;
    this.umsService.getExamStream(payload).subscribe(res => {
      console.log("res",res);
      if (res.status) {
        this.isShownBranchDiv =true
        this.BranchList = res.data;
        this.filteredListBranch = this.BranchList.slice();
      }else{
        this.isShownBranchDiv =false
        let e = 0
        this.oneCourseClick(e,'')
      }
    });
  }
  courseClick() {
    this.spinner.show();
    let payload = this.courseForm.value;
    this.courseForm.controls["course"].setValue('');
    if(this.userPermission[0].CgUi == 'C'){
      this.UserCollege= this.userPermission[0].CgId;
    }
    else{
      this.UserCollege = ''
    }
    payload['CgCode'] = this.UserCollege;
    let bar = new Promise<void>((resolve, reject) => {
      this.umsService.getCourse(payload).subscribe((res) => {
        this.spinner.hide();
        if (res.status) {
          this.courseList = res.data;
          this.filteredCourseList = this.courseList.slice();
        }
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Alert';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      });
      this.isCollegeRadioBtn = false;
      this.isCourseRadioBtn = true;

      this.isShownCollegeDiv = false;
      this.isShownCourseDiv = true;
      this.isShownBranchDiv = false;

      this.isShownCourseList = false;
      this.isShownCollegeList = false;
      resolve();
    });
    // bar.then(() => {
    //   this.addclgcourse();
    // });
  }
  selected;
  oneClgClick(e,search) {
    this.spinner.show()
    this.selected = e;
    this.selectCollege = e;
    this.isShownCourseList = true;
    this.isShownCollegeList = false;
    this.submitcourse = true;
    this.submitcollege = false;
    this.reset = true;
    this.uncheckedcourseList = [];
    this.checkedcourseList = [];
    let payload = {};
    payload['SearchString'] = search
    this.collegeId = e;
    this.umsService.getCourse(payload).subscribe((allres) => {
      this.spinner.hide()
      if (allres.data.length > 0) {
        let allcourseList = [];
        allcourseList = allres.data;
        const collegeFetchPayload = {};
        collegeFetchPayload['CgCode'] = e;
        collegeFetchPayload['CoCode'] = '';
        collegeFetchPayload['CoStr'] = this.courseForm.value['CoStr'];
        this.umsService.getCollegeCourse(collegeFetchPayload).subscribe((res) => {
          this.collegecourseList = res.data;
          this.courseForm = this.fb.group({
            course: new FormControl(''),
            college: new FormControl(e),
            CoStr: new FormControl(''),
            CollegeArr: this.fb.array([]),
            CourseArr: this.fb.array([]),
          });
          if (allcourseList !== undefined) {
            this.CourseArr = this.courseForm.get('CourseArr') as FormArray;
            allcourseList.map((element, i) => {
              element['checked'] = false;
               this.collegecourseList.forEach((elementA) => {
                if(elementA.CoStr == ''){
                  if ( element.CoCode == elementA.CoCode && e == elementA.CgCode) {
                    element['checked'] = true;
                  }
                }
                else if(elementA.CoStr != ''){
                  if ( element.CoCode == elementA.CoCode && e == elementA.CgCode && element.StrId == elementA.CoStr) {
                    element['checked'] = true;
                  }
                }
                
              });
            });
            allcourseList.forEach((element) => {
              this.CourseArr.push(
                this.fb.group({
                  clgcoursecheckbox: new FormControl(element.checked),
                  CoCgCoCode: new FormControl(element.CoName),
                  CoCode: new FormControl(element.CoCode),
                  CoCgCgCode: new FormControl(e),
                  CoCgCgName: new FormControl(element.CgName),
                  CoStr: new FormControl(element.StrId),
                  StrName: new FormControl(element.StrName),
                  toggle: false,
                })
              );
              if (element.checked == false) {
                this.uncheckedcourseList.push(element);
              } else {
                this.checkedcourseList.push(element);
              }
            });
          }
        });
      } else {
      }
    });
  }
   

  oneCourseClick(e,search) {
    this.spinner.show();
    this.submitcourse = false;
    this.submitcollege = true;
    this.reset = true;
    this.selected = e;
    this.selectCourse = e;
    this.uncheckedCollageList = [];
    this.checkedCollageList = [];
    this.isShownCourseList = false;
    this.isShownCollegeList = true;
    let payload = {};
    payload['SearchString'] = search;
    this.collegeId = e;
    this.umsService.getCollege(payload).subscribe((allResCollege) => {
      this.spinner.hide();
      if (allResCollege.data.length > 0) {
        let allcollegeList = [];
        allcollegeList = allResCollege.data;
        const courseFetchPayload = {};
        courseFetchPayload['CgCode'] = '';
        courseFetchPayload['CoCode'] = this.courseForm.value['course'];
        courseFetchPayload['CoStr'] = this.courseForm.value['CoStr'] ?  this.courseForm.value['CoStr'] : 0;
        this.umsService.getCollegeCourse(courseFetchPayload).subscribe((res) => {
          this.collegecourseList = res.data;
          this.courseForm = this.fb.group({
            course: new FormControl(this.courseForm.value['course']),
            college: new FormControl(''),
            CoStr: new FormControl(e),
            CollegeArr: this.fb.array([]),
            CourseArr: this.fb.array([]),
          });
          if (allcollegeList !== undefined) {
            this.CollegeArr = this.courseForm.get('CollegeArr') as FormArray;
            allcollegeList.map((element, i) => {
              element['checked'] = false;
              this.collegecourseList.forEach((elementA) => {
                if (
                  element.CgCode == elementA.CgCode &&
                  this.courseForm.value['course'] == elementA.CoCode
                ) {
                  element['checked'] = true;
                }
              });
            });
            console.log(allcollegeList);
            allcollegeList.forEach((element) => {
              this.CollegeArr.push(
                this.fb.group({
                  clgcoursecheckbox: new FormControl(element.checked),
                  CoCgCgCode: new FormControl(element.CgName),
                  CgCode: new FormControl(element.CgCode),
                  CoCgCoCode: new FormControl(this.courseForm.value['course']),
                  CoCgCoName: new FormControl(element.CoName),
                  CoStr : new FormControl(e),
                  toggle: false,
                })
              );
              if (element.checked == false) {
                this.uncheckedCollageList.push(element);
              } else {
                this.checkedCollageList.push(element);
              }
            });
          }
        });
      } else {
      }
    });
  }
  applyFilter(event: any){
    let search = event.target.value;
    this.searchTerm = search.toLowerCase();
  }
  // applyFilter(event: any){
  //   let search = event.target.value;
   
  //   if(this.submitcollege == true){
  //     this.oneCourseClick(this.selectCourse,search)
  //   }
  //   else if(this.submitcourse == true){
  //     this. oneClgClick(this.selectCollege,search)
  //   }
    
  // }

  clear() {
    this.courseForm = this.fb.group({
      course: new FormControl(''),
      college: new FormControl(''),
      CoStr: new FormControl(''),
      CollegeArr: this.fb.array([]),
      CourseArr: this.fb.array([]),
    });
  }

  removeCourseArr(i) {
    this.CourseArr.removeAt(i);
  }

  removeCollegeArr(i) {
    this.CourseArr.removeAt(i);
  }

  fetchCollege() {
    const payload = {};

    this.umsService.getCollege(payload).subscribe((res) => {
      if (res.status) {
        this.collegeList = res.data;
        this.filteredCollegeList = this.collegeList.slice();
      } else {
        // this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  submit() {
    this.addclgcourse();
  }

  submit1() {
    this.addclgcourse1();
  }

  addclgcourse() {
    let payload = this.courseForm.value;
    payload['CourseArr'].forEach((element, i) => {
      if (element.clgcoursecheckbox == true) {
        this.uncheckedcourseList.forEach(elementA => {
          if (element.CoCode == elementA.CoCode) {
            let xxxx = {};
            xxxx['CoCgCgCode'] = element.CoCgCgCode;
            xxxx['CoCgCoCode'] = element.CoCode;
            xxxx['CoStr'] = element.CoStr;
            this.umsService.addCourseCollege(xxxx).subscribe((res) => {
            });
          }
        });
      }
      if (element.clgcoursecheckbox == false) {
        this.checkedcourseList.forEach(elementA => {
          if (element.CoCode == elementA.CoCode) {
            this.slideToggleChange(element, 'course');
          }
        });
      }
    });
    let data = {};
    data['message'] = "Submitted Successfully";
    data['title'] = 'Information';
    data['icon'] = 'fas fa-check';
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      this.oneClgClick(this.selected,'')
      this.searchTerm = ''
    });
  }

  addclgcourse1() {
    let payload = this.courseForm.value;
    payload['CollegeArr'].forEach((element, i) => {
      if (element.clgcoursecheckbox == true) {
        this.uncheckedCollageList.forEach(elementA => {
          if (element.CgCode == elementA.CgCode) {
            let xxxx = {};
            xxxx['CoCgCgCode'] = element.CgCode;
            xxxx['CoCgCoCode'] = element.CoCgCoCode;
            xxxx['CoStr'] = element.CoStr;
            this.umsService.addCourseCollege(xxxx).subscribe((res) => {
            });
          }
        });
      }
      if (element.clgcoursecheckbox == false) {
        this.checkedCollageList.forEach(elementA => {
          if (element.CgCode == elementA.CgCode) {
            this.slideToggleChange(element, 'collage');
          }
        });
      }
    });
    let data = {};
    data['message'] = "Submitted Successfully";
    data['title'] = 'Information';
    data['icon'] = 'fas fa-check';
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      this.oneCourseClick(this.selected,'')
      this.searchTerm = ''
    });
  }

  freshCourseCollageMapping(allrecord, cgcode) {
    let data = allrecord.data;
    this.courseForm = this.fb.group({
      course: new FormControl(''),
      college: new FormControl(''),
      CoStr: new FormControl(''),
      CollegeArr: this.fb.array([]),
      CourseArr: this.fb.array([]),
    });
    this.collegeList = data.CourseArr;
    if (data !== undefined) {
      data.map((element, i) => {
        this.CourseArr = this.courseForm.get('CourseArr') as FormArray;
        this.CourseArr.push(
          this.fb.group({
            clgcoursecheckbox: new FormControl(false),
            CoCgCoCode: new FormControl(element.CoName),
            CoCode: new FormControl(element.CoCode),
            CoCgCgCode: new FormControl(cgcode),
            CoCgCgName: new FormControl(element.CgName),
            toggle: false,
          })
        );
      });
    }
  }

  fetchSelectedCourseCollege(id) {
    this.collegeId = id;
    const payload = {};
    payload['CgCode'] = id;
    payload['CoCode'] = '';
    this.umsService.getCollegeCourse(payload).subscribe((res) => {
      if (res.status) {
        this.collegecourseList = res.data;
      }
    });
  }


  slideToggleChange(e, type) {
    if (type == 'course') {
      const options = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
        body: {
          CoCgCoCode: e.CoCode,
          CoCgCgCode: e.CoCgCgCode,
          CoStr: e.CoStr,
        },
      };
      this.httpClient
        .delete(environment.serviceUrl + '/masters/college-course', options)
        .subscribe(
          (s) => { },
          (ERROR: HttpErrorResponse) => { }
        );
    } else if (type == 'collage') {
      const options = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
        body: {
          CoCgCoCode: e.CoCgCoCode,
          CoCgCgCode: e.CgCode,
          CoStr: e.CoStr,
        },
      };
      this.httpClient
        .delete(environment.serviceUrl + '/masters/college-course', options)
        .subscribe(
          (s) => { },
          (ERROR: HttpErrorResponse) => { }
        );
    }
  }

  back() {
    // this.isCollegeRadioBtn = true;
    // this.isCourseRadioBtn = true;
    // this.isShownCourseList = false;
    // this.isShownCollegeList = false;
    // this.isShownCollegeDiv = false;
    // this.isShownCourseDiv = false;
    // this.reset = false;
    // this.ColgMapCreate = false;
    // this.submitcollege = false;
    // this.submitcourse = false;
    // this.courseForm = this.fb.group({
    //   course: new FormControl(''),
    //   college: new FormControl(''),
    //   CollegeArr: this.fb.array([]),
    //   CourseArr: this.fb.array([]),
    //   radio: new FormControl(),
    // });
    // this.CollegeArr.clear();
    // this.CourseArr.clear();
    this.ngOnInit();
  }

  
  Print(){
    let submitpayload = this.CourseSearchForm.value;
    let payload1 = {}
    payload1['SearchString'] = submitpayload['SearchString'],
    payload1['MenuName'] ='Master-CoClgMap';
    let jsonString = JSON.stringify(payload1)
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 108,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId":  '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": this.SessionNo,
      "Extra1": jsonString,
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }

  redirect(to): void {
    this.router.navigate([to]);
  }
}